import React, { useState } from "react";
import PropTypes from "prop-types";

export default function Report({ reason, onChange, onSubmit }) {
  const [isClicked, setIsClicked] = useState(false);

  function handleClick() {
    setIsClicked(!isClicked);
  }

  return (
    <div className="report">
      <button
        className="report-button"
        onClick={handleClick}
        value="Rapportera"
      >Rapportera</button>
      {isClicked ? (
        <div>
          <form onSubmit={onSubmit}>
            <textarea
              className="report-description"
              value={reason}
              placeholder="Kommentera gärna varför detta inte känns okej."
              maxLength="1000"
              onChange={onChange}
            />
            <button type="submit">Skicka</button>
          </form>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

Report.propTypes = {
  reason: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
